import Chart from "chart.js";

export class Charts {
    /**
     * Finds each chart in the given selector and initialises Chart.JS on this
     * @param selector
     */
    static init(selector) {
        $('div[type="chart"]', selector).each((key, item) => {
            this.initChartJS(item);
        });
    }

    /**
     * Initialises Chart.JS on the specified element.
     *
     * @param element
     */
    static initChartJS(element) {
        let $element = $(element),
            chart = undefined,
            colors = [
                '#6f1a31',
                '#ff982c',
            ],
            params = {
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    // elements: {
                    //     line: {
                    //         fill: false
                    //     }
                    // },
                    responsive: true,
                }
            };

        $element.append('<canvas></canvas>')

        let ctx = $('canvas', $element);

        //Loading the data from the source defined on the table element
        if($element.data('src') !== undefined) {
            $.ajax({
                url: $element.data('src'),
                method: 'POST',
                dataType: 'json',
                data: {
                    _token: window.token.content,
                },
                success: function (res) {
                    let tempLabels = [];
                    let tempData = [];
                    let bgColors = [];

                    for (let i = 0; i < res.data.length; i++) {
                        bgColors.push(colors[i % colors.length]);
                    }

                    const mappedVals = res.values.map( x => {
                      return String(x).replace(',', '')
                    })

                    params = Object.assign(params, {
                        type: res.chartType,
                        data: {
                            labels: res.labels,
                            datasets: [
                                {
                                    pointBorderColor: "#ff982c",
                                    pointBackgroundColor: "#ff982c",
                                    pointHoverBackgroundColor: "#ff982c",
                                    pointHoverBorderColor: "#ff982c",
                                    pointBorderWidth: 10,
                                    pointHoverRadius: 10,
                                    pointHoverBorderWidth: 1,
                                    pointRadius: 3,
                                    borderColor : '#6f1a31',
                                    fill: true,
                                    label: res.name,
                                    data: mappedVals,
                                    backgroundColor: (res.chartType === 'bar' ? bgColors : '#6f1a31'),
                                }
                            ]
                        }
                    });

                    chart = new Chart(ctx, params);
                }
            });
        }
    }
}
